import React, { useEffect } from 'react'
import { Button, Card, Form, Input, Select } from 'antd'
import {
  $isSuccessCreate,
  $roles,
  closeModal,
  rolesMounted,
  submitCreateGroup,
} from './model'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'
import { path } from '../../../../libs'

interface FormData {
  name: string
  role: string
}

export const CreateGroup = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm<FormData>()

  const roles = useUnit($roles)
  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  useEffect(() => {
    rolesMounted()
  }, [])

  useEffect(() => {
    if (isSuccessCreate) {
      navigate(path.groups.entry())
      modalCloseFn()
    }
  }, [isSuccessCreate])

  const onFinish = (values: FormData) => {
    submitCreateGroup(values)
  }

  return (
    <Card title={<strong>Create group</strong>}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 520 }}
        initialValues={{ name: '', role: '' }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Имя обязательно' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Роль обязательна' }]}
        >
          <Select
            placeholder="Выберите роль"
            options={roles.map((r) => ({
              value: r.id,
              label: r.description || r.id,
            }))}
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
